export enum CoBrandCardGroupEnum {
  'SureBank Concession'= 1,
  'Myco Cash Access Iss',
  'Wealth&Rewards',
  'ePlatinum',
  'Office Admin',
  'StatusMoney',
  'Card Issuer',
  'Trademarked CI',
  'EDOS Merchant',
  'Convenience Card',
  'BizBank Account',
  'Wizzit',
  'Consumer Fair',
  'Medibucks',
  'Business OnTheGo',
  'SC Branch',
  'Premium'
}

export namespace CoBrandCardGroupEnum {
  export function values() {
    return Object.keys(CoBrandCardGroupEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
